module.exports = __webpack_public_path__ + "img/shipin_fengmian.52cb7b6a.png";